import { TypographyVariantsOptions } from '@mui/material'

export const typography: TypographyVariantsOptions = {
  fontFamily: ['Noto Sans', 'Montserrat', 'serif'].join(','),
}
